<template>
	<div class="success">
		<div class="success-content">
			<div class="success-header">
				<div class="success-icon-wrapper">
					<mdb-icon icon="check" class="success-icon" />
				</div>
			</div>
			<div class="success-body">
				<h2 class="text-center mb-4">Thank You</h2>
				<p class="text-center">
					Your job has been lodged successfully.
				</p>
				<hr />
				<div class="text-right">
					<router-link :to="{ name: 'home' }">
						<mdb-btn icon="home" :iconRight="true" color="secondary"
							>Home Page</mdb-btn
						>
					</router-link>

					<router-link :to="{ name: 'job-list' }">
						<mdb-btn
							icon="arrow-right"
							:iconRight="true"
							class="btn-color-primary"
							>List Jobs</mdb-btn
						>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mdbBtn, mdbIcon } from 'mdbvue'
export default {
	components: {
		mdbBtn,
		mdbIcon
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/success.scss';
</style>
